<!-- Localized -->
<template>
  <div
    class="flex flex-1 overflow-y-auto flex-col space-y-6 max-h-full max-w-full overflow-x-hidden"
  >
    <div class="grid flex-1 grid-cols-3 space-x-6 overflow-y-auto max-w-full">
      <div
        class="overflow-y-auto bg-card-bg p-4 rounded-md max-w-full col-span-2"
        style="min-height: 300px"
      >
        <div
          v-if="loadingState && loadingState.packages"
          class="flex justify-center items-center min-h-full"
        >
          <Loader />
        </div>
        <ListView
          :disableCheckbox="loadingState.assigningpackages || !disablePackages"
          :title="$t('pages.tenant_client.assigned_packages')"
          @rowClick="disablePackages && handlePackageClick($event)"
          @permissionClick="showGroupsModal"
          v-else
          :listItems="filterdPackages"
          :showPermissions="true"
          :showSearch="true"
          class="h-full overflow-y-auto"
          @handleFilterResult="handleFilterResult($event, 'packages')"
          valueKey="package_name"
        >
          <template #listheader>
            <div class="flex items-center p-2 gap-2">
              <div class="flex gap-3 justify-between w-full">
                <div class="flex truncate items-center gap-3 w-1/2"></div>
                <div class="flex items-center gap-3 w-1/2">
                  <div class="w-1/2 truncate px-4">
                    Assigned {{ getTenantName }}
                  </div>
                  <div class="w-1/2 truncate px-4">
                    {{ clientDetails?.name }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </ListView>
      </div>
      <div
        class="overflow-y-auto bg-card-bg p-4 rounded-md max-w-full"
        style="min-height: 300px"
      >
        <div
          v-if="loadingState && loadingState.checks"
          class="flex justify-center items-center min-h-full"
        >
          <Loader />
        </div>
        <ListView
          v-else
          :title="$t('pages.tenant_client.assigned_checks')"
          :disableCheckbox="loadingState.assigningchecks || !disableChecks"
          :listItems="filterdChecks"
          @rowClick="disableChecks && handleCheckClick($event)"
          :showSearch="true"
          class="h-full overflow-y-auto"
          @handleFilterResult="handleFilterResult($event, 'checks')"
        />
      </div>
    </div>
    <!-- <div class="flex justify-between">
            <Button text="cancel" type="outline" />
            <Button text="Save" type="primary" />
        </div> -->

    <GroupsModal
      ref="status-permissions-modal"
      :groups="groups"
      :value="value"
      :additional-user-list="true"
      :tenant-name="getTenantName"
      @input="setSelectedGroups"
      @rowClick="onRowClick"
      @cancel="onGroupsModalCancel"
      @onSubmit="onGroupsModalSubmit"
    />
  </div>
</template>

<script>
// import Button from "@shared/components/button";
import ListView from "@shared/components/lists";
import axios from "@/axios";
import Loader from "@shared/loader";
import { getChecksList } from "@/modules/checks/services.js";
import { getAllClientPackages, getChecksAssignedtoClient } from "../services";
import { checkPermission } from "@shared/utils/functions";
import { mapGetters } from "vuex";
import GroupsModal from "@shared/components/GroupsModal";
import { fetchTenantGroups } from "@shared/workflow/service.js";

export default {
  name: "client-package-and-check",
  components: {
    // Button,
    ListView,
    Loader,
    GroupsModal,
  },
  props: {
    clientDetails: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loadingState: {
        packages: false,
        checks: false,
        assigningpackages: false,
        assigningchecks: false,
      },
      packages: [],
      checks: [],
      serchValues: {
        checks: "",
        packages: "",
      },
      clientPackages: [],
      clientChecks: [],
      clientId: null,
      groups: {
        tenant: [],
        client: [],
      },
      statusPerGroupsMap: {},
      selectedPackageId: null,
      groupsOriginData: [],
      openModalType: "",
      selectedAssignedPackage: null,
      tenantUserData: [],
      tenantGroupData: [],
      clientUserData: [],
      clientGroupData: [],
    };
  },
  computed: {
    ...mapGetters(["getTenantName", "getTenantId"]),
    value() {
      return this.defaultGroupIds;
    },
    defaultGroupIds() {
      return [
        ...this.groups.tenant.filter((el) => el.selected).map((el) => el?.id),
        ...this.groups.client.filter((el) => el.selected).map((el) => el?.id),
      ];
    },
    filterdChecks() {
      let filteredData = [];
      if (!this.checkPermission("check.read")) {
        return filteredData;
      }
      if (this.checks && this.checks.length > 0) {
        filteredData = this.checks
          .map((e) => {
            for (let i of this.clientChecks) {
              if (i.id === e.id) {
                return { ...e, checked: true, orderkey: i?.orderkey };
              }
            }
            return { ...e, checked: false };
          })
          .filter((el) =>
            el.name
              ?.toLowerCase()
              .includes(this.serchValues.checks.toLowerCase())
          );
      } else {
        filteredData = this.clientChecks
          .map((el) => ({ ...el, checked: true }))
          .filter((el) =>
            el.name
              ?.toLowerCase()
              .includes(this.serchValues.checks.toLowerCase())
          );
      }
      filteredData = filteredData.sort((a, b) => {
        if (a.orderkey !== undefined && b.orderkey !== undefined) {
          return b.orderkey - a.orderkey;
        }
        if (a.orderkey !== undefined) {
          return -1;
        }
        if (b.orderkey !== undefined) {
          return 1;
        }
        return 0;
      });

      return filteredData;
    },
    filterdPackages() {
      let filteredpackagesData = [];
      if (!this.checkPermission("package.read")) {
        return filteredpackagesData;
      }
      if (this.packages && this.packages.length > 0) {
        filteredpackagesData = this.packages
          ?.map((e) => {
            for (let i of this.clientPackages) {
              if (i.package_id === e.id) {
                return { ...e, checked: true, orderkey: i?.orderkey };
              }
            }
            return { ...e, checked: false };
          })
          ?.filter((el) =>
            el.package_name
              ?.toLowerCase()
              ?.includes(this.serchValues.packages.toLowerCase())
          );
        // return this.packages?.filter((el) => el.package_name?.toLowerCase()?.includes(this.serchValues.packages.toLowerCase()));
      } else {
        filteredpackagesData = this.clientPackages
          ?.map((el) => ({ ...el, checked: true }))
          .filter((el) =>
            el.package_name
              ?.toLowerCase()
              ?.includes(this.serchValues.packages.toLowerCase())
          );
      }
      filteredpackagesData = filteredpackagesData.sort((a, b) => {
        if (a.orderkey !== undefined && b.orderkey !== undefined) {
          return b.orderkey - a.orderkey;
        }
        if (a.orderkey !== undefined) {
          return -1;
        }
        if (b.orderkey !== undefined) {
          return 1;
        }
        return 0;
      });

      return filteredpackagesData;
    },
    disablePackages() {
      return (
        this.checkPermission("client.edit") &&
        this.checkPermission("package.read")
      );
    },
    disableChecks() {
      return (
        this.checkPermission("client.edit") &&
        this.checkPermission("check.read")
      );
    },
  },
  async created() {
    this.loadingState.packages = true;
    this.loadingState.checks = true;
    this.clientId = this.$route.params.clientId;
    // this.getClientChecks();
    // this.fetchChecksList();
    // this.getClientpackage();
    // this.fetchTenantPackages();
    // call API's on load parallely
    await Promise.allSettled([
      this.getClientChecks(),
      this.fetchChecksList(),
      this.fetchTenantPackages(),
      this.getClientpackage(),
      //
      this.fetchTenantGroupsList(),
      this.fetchTenantUserList(),
      this.fetchClientGroupsList(),
      this.fetchClientUserList(),
    ]);
  },
  methods: {
    checkPermission,
    onRowClick(row) {
      console.log("row", row);
      if (row.type === "tenant") {
        // find out the selected element and mark selected
        this.groups.tenant = this.groups.tenant.map((el) => ({
          ...el,
          selected: el.id === row.id ? !el.selected : el.selected,
        }));
      } else if (row.type === "client") {
        this.groups.client = this.groups.client.map((el) => ({
          ...el,
          selected: el.id === row.id ? !el.selected : el.selected,
        }));
      }
    },

    async fetchClientUserList() {
      let url = `user/client/${this.clientId}`;
      try {
        let { data } = await axios.get(url);
        this.clientUserData = data;
      } catch (error) {
        console.log(error, "<<<<error while fetching users");
      }
    },
    async fetchClientGroupsList() {
      try {
        let { data } = await axios.get(`group/client/${this.clientId}`);
        this.clientGroupData = data;

        console.log("data", data);
      } catch (err) {
        console.log("err", err);
      }
    },
    async fetchTenantUserList() {
      let url = `user/tenant/${this.getTenantId}`;
      try {
        let { data } = await axios.get(url);
        this.tenantUserData = data;
      } catch (error) {
        console.log(error, "<<<<error while fetching users");
      }
    },

    async fetchTenantGroupsList() {
      try {
        const groups = await fetchTenantGroups(this.getTenantId);
        this.tenantGroupData = groups;
      } catch (err) {
        console.log("err", err);
      }
    },
    async showGroupsModal({ id, type }) {
      this.selectedPackageId = id;
      this.selectedAssignedPackage = this.clientPackages.find(
        (el) => el.package_id === id
      );
      this.openModalType = type;

      if (type === "tenant") {
        this.groups.tenant = this.tenantGroupData.map((el) => ({
          ...el,
          selected:
            this.selectedAssignedPackage?.tenant_group_ids?.includes(el.id) ||
            false,
        }));
        this.groups.client = this.tenantUserData.map((el) => ({
          id: el.id,
          name: el.user_name,
          selected:
            this.selectedAssignedPackage?.tenant_user_ids?.includes(el.id) ||
            false,
        }));
      } else if (type === "client") {
        this.groups.tenant = this.clientGroupData.map((el) => ({
          ...el,
          selected: this.selectedAssignedPackage?.client_group_ids?.includes(
            el.id
          ),
        }));
        this.groups.client = this.clientUserData?.map((el) => ({
          id: el.id,
          name: el.user_name,
          selected: this.selectedAssignedPackage?.client_user_ids?.includes(
            el.id
          ),
        }));
      }

      this.$refs["status-permissions-modal"]?.$refs[
        "status-permissions-content"
      ]?.showModal();
    },

    async fetchTenantPackages() {
      // this.isLoading = true
      this.loadingState.packages = true;
      try {
        const { data } = await axios.get(`/screening-package`);
        this.packages = data;
      } catch (error) {
        console.log(error, ">>error");
      }
      this.loadingState.packages = false;
    },
    async fetchChecksList() {
      this.loadingState.checks = true;
      try {
        this.checks = await getChecksList(
          this.$store.getters.getTenantId,
          1000
        );
      } catch (error) {
        console.log(error, ">>>>error");
      }
      this.loadingState.checks = false;
    },
    // selectAll(event, type){
    //     this[type] = this[type].map(el => ({...el, checked:event || false}))
    // },
    handleFilterResult(event, type) {
      this.serchValues[type] = event;
    },
    async handlePackageClick({ row, value }) {
      value
        ? await this.handleLinkPackages(row)
        : await this.removePackage(row);
    },
    async getClientpackage() {
      this.loadingState.packages = true;
      try {
        this.clientPackages = await getAllClientPackages(this.clientId);
        this.clientPackages.reverse();
        this.clientPackages?.forEach((item, index) => (item.orderkey = index));
      } catch (error) {
        console.log(error, "error");
      }
      this.loadingState.packages = false;
    },
    async handleLinkPackages(packageData) {
      const url = `/screening-package/${packageData.id}/${this.clientId}`;
      this.loadingState.assigningpackages = true;
      try {
        const payload = {
          tenant_user_ids: this.tenantUserData.map((el) => el.id),
          tenant_group_ids: this.tenantGroupData.map((el) => el.id),
          client_user_ids: this.clientUserData.map((el) => el.id),
          client_group_ids: this.clientGroupData.map((el) => el.id),
        };
        let { data } = await axios.put(url, payload);
        let package_data = {
          ...packageData,
          id: data.client_package_id,
          package_id: packageData.id,
        };
        this.clientPackages.push(package_data);
        this.clientPackages?.forEach((item, index) => (item.orderkey = index));
        this.getClientpackage();
        this.$toast.success(
          this.$t("pages.tenant_client.package_linked_with_client")
        );
      } catch (error) {
        this.$toast.warning(
          error.response.data.detail ||
            "Error while attaching package with client !"
        );
      }
      this.loadingState.assigningpackages = false;
    },
    async removePackage(packageData) {
      this.loadingState.assigningpackages = true;
      const url = `/screening-package/${packageData.id}/${this.clientId}`;
      try {
        let { data } = await axios.delete(url);
        this.clientPackages = this.clientPackages.filter(
          (el) => el.package_id !== data.package_id
        );
        this.$toast.success(data.detail);
      } catch (error) {
        // this.clientPackages.push(packageData)
        this.serchValues.packages = "";
        await this.getClientpackage();
        this.$toast.warning(
          error.response.data.detail ||
            "Error while unassigning check from client !"
        );
      }
      this.loadingState.assigningpackages = false;
    },
    async handleCheckClick({ row, value }) {
      value
        ? await this.handleLinkCheck(row)
        : await this.unassignChecksToClient(row);
    },
    async getClientChecks() {
      this.clientChecks = await getChecksAssignedtoClient(this.clientId);
      this.clientChecks.reverse();
      this.clientChecks?.forEach((item, index) => (item.orderkey = index));
    },
    async handleLinkCheck(checkData) {
      this.loadingState.assigningchecks = true;
      const url = `/tenant-check/${checkData.id}/assign-to-client`;
      let payload = {
        client_id: this.clientId,
      };
      try {
        let { data } = await axios.post(url, payload);
        this.clientChecks.push(checkData);
        this.clientChecks?.forEach((item, index) => (item.orderkey = index));
        this.$toast.success(
          data.message ||
            this.$t("pages.tenant_client.success_assigned_to_client")
        );
      } catch (error) {
        this.$toast.warning(
          error.response.data.detail ||
            "Error while attaching package with client !"
        );
      }

      this.loadingState.assigningchecks = false;
    },

    async unassignChecksToClient(check) {
      this.loadingState.assigningchecks = true;
      const url = `/tenant-check/${check.id}/unassign-from-client`;
      let payload = {
        client_id: this.clientId,
      };
      try {
        let { data } = await axios.post(url, payload);
        this.clientChecks = this.clientChecks.filter(
          (el) => el.id !== check.id
        );
        this.$toast.success(data.message);
      } catch (error) {
        this.$toast.warning(
          error.response.data.detail ||
            "Error while unassigning check from client !"
        );
      }
      this.loadingState.assigningchecks = false;
    },

    setSelectedGroups({ type, selected }) {
      if (type === "tenant") {
        this.groups.tenant = this.groups.tenant.map((el) => ({
          ...el,
          selected: selected,
        }));
      }
      if (type === "client") {
        this.groups.client = this.groups.client.map((el) => ({
          ...el,
          selected: selected,
        }));
      }
    },

    onGroupsModalCancel() {
      this.$set(this.statusPerGroupsMap, this.selectedStatusId, [
        ...this.groupsOriginData,
      ]);
    },

    async onGroupsModalSubmit() {
      const selectedUserIds = this.groups.client
        .filter((el) => el.selected)
        .map((el) => el.id);
      const selectedGroupIds = this.groups.tenant
        .filter((el) => el.selected)
        .map((el) => el.id);

      const payload = {
        tenant_user_ids:
          this.openModalType === "tenant"
            ? selectedUserIds
            : this.selectedAssignedPackage?.tenant_user_ids,
        tenant_group_ids:
          this.openModalType === "tenant"
            ? selectedGroupIds
            : this.selectedAssignedPackage?.tenant_group_ids,
        client_user_ids:
          this.openModalType === "client"
            ? selectedUserIds
            : this.selectedAssignedPackage?.client_user_ids,
        client_group_ids:
          this.openModalType === "client"
            ? selectedGroupIds
            : this.selectedAssignedPackage?.client_group_ids,
      };

      try {
        await axios.put(
          `/screening-package/${this.selectedPackageId}/${this.clientId}`,
          payload
        );
        this.$toast.success(
          this.$t("general.save_success")
        );
        this.$refs["status-permissions-modal"]?.$refs[
          "status-permissions-content"
        ]?.hideModal();
        this.getClientpackage();
      } catch (error) {
        this.$toast.warning(
          error.response.data.detail ||
            this.$t("general.default_error")
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
